import React from 'react';
import { TWMenuItem } from '../TWMenuItem';
import { jsx as _jsx } from "react/jsx-runtime";
export var TWMenu = function TWMenu(_ref) {
  var items = _ref.items;
  return /*#__PURE__*/_jsx("ul", {
    className: "list-style-none m-0",
    children: items.map(function (item) {
      return !item.hidden && /*#__PURE__*/_jsx(TWMenuItem, {
        item: item
      }, item.text);
    })
  });
};